import { OpenHours } from "./useOpenHours";

export function getOpenHours(openHours: OpenHours) {
  const customHours = openHours?.custom_hours.compiled;

  const combinedDays = openHours?.combined_days;

  let openHoursString = "";

  const now = new Date();
  const regularDailyHours = combinedDays[`${now.getDay()}`];
  const regularCloseTime =
    regularDailyHours.close.value && new Date(regularDailyHours.close.value);

  regularCloseTime?.setDate(now.getDate());
  regularCloseTime?.setFullYear(now.getFullYear());
  regularCloseTime?.setMonth(now.getMonth());

  const todayCustomHours =
    customHours &&
    customHours[`${now.getMonth()}${now.getDate()}`] &&
    customHours[`${now.getMonth()}${now.getDate()}`][0];

  let customCloseTime = todayCustomHours?.close?.value
    ? new Date(todayCustomHours.close.value)
    : undefined;

  if (customCloseTime && customCloseTime > now) {
    return `Open today ${getTimeString(
      todayCustomHours?.open?.value
    )} - ${getTimeString(todayCustomHours?.close?.value)}`;
  }

  if (!todayCustomHours && regularCloseTime > now) {
    return `Open today ${getTimeString(
      regularDailyHours?.open?.value
    )} - ${getTimeString(regularDailyHours?.close?.value)}`;
  }

  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const tomorrowCustomHours =
    customHours &&
    customHours[`${tomorrow.getMonth()}${tomorrow.getDate()}`] &&
    customHours[`${tomorrow.getMonth()}${tomorrow.getDate()}`][0];

  const tomorrowHours =
    tomorrowCustomHours || combinedDays[`${tomorrow.getDay()}`];

  function getTimeString(datestring: Date) {
    return new Date(datestring).toLocaleString("en-US", {
      hour: "numeric",
      hour12: true,
    });
  }

  if (tomorrowHours.open.value) {
    openHoursString = `Open tomorrow ${getTimeString(
      tomorrowHours?.open?.value
    )} - ${getTimeString(tomorrowHours?.close?.value)}`;
  } else {
    openHoursString = `Closed tomorrow`;
  }

  return openHoursString;
}
